import _ from 'lodash';
import { Consumption } from '../components/Pages/OverviewPage';
import { ADDED_FILTERS_SOURCE, FIELD_VALUES, FILTER } from '../utils/filters';
import { EnergyProduct } from '../utils/product';

export enum ENERGY_TARIFF_TYPE {
  HIGH = 'high',
  LOW = 'low',
  SINGLE = 'single',
}

export enum SORTING_OPTIONS {
  Price = 0,
  Highest_Redelivery_Tariff = 1,
  Most_Sustainable = 2,
  Least_Sustainable = 3,
}

export const SORTING_ASCENDING_ORDER = {
  [SORTING_OPTIONS.Price]: false,
  [SORTING_OPTIONS.Highest_Redelivery_Tariff]: true,
  [SORTING_OPTIONS.Most_Sustainable]: true,
  [SORTING_OPTIONS.Least_Sustainable]: false,
};

export const SORTING_REFERENCE = {
  [SORTING_OPTIONS.Price]: 'price.month.total',
  [SORTING_OPTIONS.Highest_Redelivery_Tariff]:
    'price.breakdown.tariffs.electricity.high.supply[0].total',
  [SORTING_OPTIONS.Most_Sustainable]: 'filters.sustainabilityScore',
  [SORTING_OPTIONS.Least_Sustainable]: 'filters.sustainabilityScore',
};

export function addFiltersFromData(
  data: EnergyProduct[],
  consumption: Consumption,
): EnergyProduct[] {
  let newData: EnergyProduct[] = [];

  for (const product of data) {
    const { filters, ...restProduct } = product;

    let additionalFilters: {
      [key: string]: any;
    } = {
      [FILTER.CONSTANT_TARIFF]: String(
        Boolean(filters[FILTER.CONTRACT_DURATION]),
      ),
      [FILTER.POSTCODEROOSREGELING]: _.get(
        product,
        ADDED_FILTERS_SOURCE[FILTER.POSTCODEROOSREGELING],
      ),
      [FILTER.SUSTAINABILITY_LABEL]: FIELD_VALUES[FILTER.SUSTAINABILITY_LABEL](
        Number(
          _.get(product, ADDED_FILTERS_SOURCE[FILTER.SUSTAINABILITY_LABEL]) ||
            0,
        ),
      ),
      [FILTER.SUSTAINABILITY_SCORE]: Number(
        _.get(product, ADDED_FILTERS_SOURCE[FILTER.SUSTAINABILITY_SCORE]) || 0,
      ),
      [FILTER.ORDERABLE]: _.get(
        product,
        ADDED_FILTERS_SOURCE[FILTER.ORDERABLE],
        false,
      ),
    };

    const electricityProduct = product.products.find((item) => {
      return item.category === 'electricity';
    });

    if (electricityProduct) {
      additionalFilters = {
        ...additionalFilters,
        [FILTER.GREEN_POWER]: electricityProduct['filters']['green'],
      };
    }

    restProduct.compare = false; //compare is used for the compare checkbox

    newData.push({
      ...restProduct,
      filters: {
        ...filters,
        ...additionalFilters,
      },
      ...consumption,
    });
  }

  return newData;
}
